import { Pipe, PipeTransform } from '@angular/core';

import type { ImageEntity } from '@fantaz/shared/data-access/models';

@Pipe({
  name: 'prizeImage',
  standalone: true,
})
export class PrizeImagePipe implements PipeTransform {
  transform(image: string | ImageEntity | undefined): string {
    if (typeof image === 'string') {
      return image;
    }

    return image?.url || '';
  }
}
